module.exports = __webpack_public_path__ + "static/media/licenta30.bfe591a7.png";